import { render } from "./BaselineExplanationSection.vue?vue&type=template&id=b86c524a"
import script from "./BaselineExplanationSection.vue?vue&type=script&lang=js"
export * from "./BaselineExplanationSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__